import React from "react";
import { businessStore } from "../../../stores";

const useAccountManagerLogic = () => {
  const accountManager = businessStore.business.accountManager;
  return { accountManager };
};

export default useAccountManagerLogic;
